module.exports = __webpack_public_path__ + "img/V32.173c8434.jpg";